import lead_logo from "../assets/lead_logo.svg";
import lead_techbook_logo from "../assets/lead_techbook_logo.svg";
import pinnacle_log from "../assets/pinnacle_plus_logo.png";
import propel_logo from "../assets/propel_logo.png";
import active_teach_logo from "../assets/active_teach_logo.svg";
import academia_logo from "../assets/academia_logo.svg";
import buildr_logo from "../assets/buildr_logo.svg";
import { ReactComponent as pendrive_logo } from "../assets/pendrive.svg";
import { ReactComponent as panel_logo } from "../assets/panel.svg";

export const OPP_CONSTANTS = {
  resources: {
    MAX_LIMIT: 10,
    MAX_FILE_SIZE: 1024 * 1024 * 2,
  },
  icons: {
    warning: "fa-triangle-exclamation",
    confirm: "fa-truck-fast",
  },
  title: {
    warning: "Warning",
    confirm: "Are you sure?",
    orderSummary: "Order Summary",
    addAttachments: "Add Attachments",
  },
  btns: {
    cancel: "Cancel",
    close: "Close",
    confirm: "Submit",
    start: "Trigger QC",
    stopQC: "Stop QC",
    startAll: "Trigger QC for All",
    uploadAllYamls: "Upload All Yamls",
    validatingYaml: "Validating",
    uploadYaml: "Upload Yaml",
    readyShipment: "Ready for Shipment",
    submittedShipment: "Shipment Submitted",
    save: "Save",
    update: "Update",
    updating: "Updating",
    addMedia: "Add Files",
    upload: "Upload",
  },
  messages: {
    default: "Please enter Order Id to get the details.",
    notAvailable:
      "It seems that the orderId you entered does not contain valid information <br /> or is invalid. Please enter a valid orderId.",
    wentWrong:
      "Unable to fetch the data, Something went wrong! Please try again",
    warningHint:
      "It appears that there might be some missing items in your order. Could you kindly provide the reason for the partial shipment or any details regarding the incomplete status of your order?",
    confirm:
      "Proceeding with the shipment completion is irreversible. Once submitted, you won't have the ability to make any further edits. Are you sure you want to proceed?",
    unableToTrigger: "Unable to Start QC, Due to network or Brodcast issues",
    unableToUpdate: "Somthing went wrong! unable to set Serial Id you entered",
    invalidFcmToken:
      "Unable to start QC, as the device is not yet registered. Please update the configuration and retry.",
    failToSubmit: "Unable to submit, something went wrong, Please try again",
    successSubmit: "Your order successfully submitted",
    invalidSerialId:
      "Please ensure the provided SerialID is unique, entered SerialID is already used with in the same order.",
    failToSubmitAction: "Unable to update SD card info, Please try again",
    invalidYaml: "Please ensure the selected Yaml is valid and right format.",
    partialYamlUpload:
      "You are required to upload exactly {max_count} files in total, or alternatively, you may upload files individually for each device.",
    exceedYamllimit:
      "The maximum limit for file uploads is {max_count} files. Please ensure you do not exceed this number.",
    invalidMedia: "Please ensure the selected file is valid and right format.",
    exceededMediaLimit:
      "Please ensure the selected file size not exceeded {max_size}",
    duplicateMedia:
      "The selected file is a duplicate. Please choose a different file.",
    failedToUpload:
      "We encountered an issue while uploading file(s). Please try again",
    invalidFileName:
      "The file name contains invalid or special characters. Please rename the file without these characters.",
    deviceInUse:
      "This device is already mapped to other orders. Reason for mapping the device to this order: {reason}. Mapped orders: {orders}",
    unsavedFile:
      "This file will be saved when you click on Upload Files."
  },
};

// Post 5.x app release, we need to provide LEAD package for all product types
export const PRODUCT_THEME = {
  LEAD: {
    color: "#ff7929",
    icon: lead_logo,
    packageName: "com.leadschool.teacherapp1920",
  },
  LEAD_TECHBOOK: {
    color: "#ff7929",
    icon: lead_techbook_logo,
    packageName: "com.leadschool.teacherapp1920",
  },
  PINNACLE: {
    name: "Pinnacle",
    color: "#142a4f",
    icon: pinnacle_log,
    packageName: "com.leadschool.teacherapp1920",
  },
  "PINNACLE+": {
    name: "Pinnacle+",
    color: "#142a4f",
    icon: pinnacle_log,
    packageName: "com.leadschool.teacherapp1920",
  },
  PROPEL: {
    color: "#f04a23",
    icon: propel_logo,
    packageName: "com.leadschool.teacherapp1920",
  },
  ACTIVE_TEACH: {
    color: "#2E3A59",
    icon: active_teach_logo,
    packageName: "com.leadschool.teacherapp1920",
  },
  ACADEMIA: {
    color: "#007944",
    icon: academia_logo,
    packageName: "com.leadschool.teacherapp1920",
  },
  BUILDR: {
    color: "#6E2E8A",
    icon: buildr_logo,
    packageName: "com.leadschool.teacherapp1920",
  },
  OTHER: {
    color: "#ff7929",
    icon: lead_logo,
  },
  BRAND_LEAD_ACTIVE: {
    color: "#ff7929",
    icon: lead_logo,
    packageName: "com.leadschool.teacherapp1920",
  },
  BRAND_LEAD_TECHBOOK: {
    color: "#ff7929",
    icon: lead_logo,
    packageName: "com.leadschool.teacherapp1920",
  },
  "BRAND_PINNACLE+": {
    color: "#ff7929",
    icon: lead_logo,
    packageName: "com.leadschool.teacherapp1920",
  },
  BRAND_PROPEL: {
    color: "#ff7929",
    icon: lead_logo,
    packageName: "com.leadschool.teacherapp1920",
  },
};

export const HARDWARE_TYPE = {
  TAB: {
    name: "tab",
    icon: "tablet",
    color: "#336D00",
    serialIdLength: 8,
    type: "fa",
  },
  TV: {
    name: "tv",
    icon: "tv",
    color: "#000",
    type: "fa",
  },
  SDCARD: {
    name: "sdcard",
    icon: "sd-card",
    color: "#A91D16",
    type: "fa",
  },
  PANEL: {
    name: "panel",
    icon: panel_logo,
    color: "#004B87",
    type: "svg",
  },
  PENDRIVE: {
    name: "pendrive",
    icon: pendrive_logo,
    color: "#5E4B00",
    type: "svg",
  }
};

export const ORDER_DATA_SUMMARY = {
  ORDER_DETAILS: {
    productType: "Product Name",
    deviceCount: "Hardware",
    deviceInfo: "Hardware Info",
    schoolId: "School Id",
    schoolName: "School Name",
    profileName: "SD Card Profile",

    package_name: null,
    app_version: null,
    login_id: null,
    password: null,
    group_id: null,
  },

  deviceInfo: {
    id: "id",
    deviceNo: "Device No",
    configuration_id: "Configuration Id",
    configuration_name: "Configuration Name",
    sd_card_size: "SDCrad Size",
    sd_card_profile_name: "SDCrad Profile",
    deviceModel: "Device Model",
    deviceType: "Device Type",

    lastActionId: "lastActionId",
    run_one_click: "run_one_click",
    auto_logout: "auto_logout",
    status: "status",
  },
};

export const ORDER_STATUS = {
  COMPLETED: "Completed",
  FAILURE: "Failure",
  INPROGRESS: "Draft",
};

export const DEVICE_STATUS = {
  SUCCESS: "Success",
  FAILURE: "Failure",
  INPROGRESS: "InProgress",
  DRAFT: "Draft",
  TIMEOUT: "Timeout",
  PAUSED: "Paused",
};

export const DEVICE_TYPE_INFO = {
  TV: [
    {
      name: "Hyundai LED TV 39\"",
      materialCode: "1100001292",
    },
    {
      name: "Hyundai LED TV 43\"",
      materialCode: "1100002239",
    },
    {
      name: "Hyundai LED TV 50\"",
      materialCode: "1100001715",
    },
    {
      name: "Hyundai LED TV 55\"",
      materialCode: "1100001307",
    },
    {
      name: "Hyundai LED TV 65\"",
      materialCode: "1100002245",
    },
    {
      name: "Xentec LED TV 65\"",
      materialCode: "",
    },
    {
      name: "Xentec LED TV 55\"",
      materialCode: "",
    },
    {
      name: "Xentec LED TV 50\"",
      materialCode: "",
    },
    {
      name: "Xentec LED TV 43\"",
      materialCode: "1100006207",
    },
    {
      name: "Xentec LED TV 39\"",
      materialCode: "1100000940",
    },
    {
      name: "Intex LED TV 43\"",
      materialCode: "1100007758",
    },
    {
      name: "Hisense LED TV 55\"",
      materialCode: "1100007753",
    },
    {
      name: "Hisense LED TV 65\"",
      materialCode: "1100007754",
    },
  ],
  TAB: [
    {
      name: "Lenovo TB-7306F",
      materialCode: "1800001489",
    },
    {
      name: "TB301FU",
      materialCode: "1800001326"
    },
    {
      name: "TB301XU",
      materialCode: "1100007595",
    },
  ],
  SDCARD: [
    {
      name: "64 GB",
      materialCode: "1100000596",
    },
    {
      name: "128 GB",
      materialCode: "1100001291",
    },
    {
      name: "256 GB",
      materialCode: "1100001291",
    }
  ],
  PENDRIVE: [
    {
      name: "16 GB",
      materialCode: "100",
    },
    {
      name: "32 GB",
      materialCode: "100",
    },
    {
      name: "64 GB",
      materialCode: "100",
    },
    {
      name: "128 GB",
      materialCode: "100",
    },
  ],
  PANEL: [
    {
      "name": "IFP - Screen Size 65\" 8/128 GB",
      "materialCode": "1100007538"
    },
    {
      "name": "IFP - Screen Size 75\" 8/128 GB",
      "materialCode": "1100007539"
    },
    {
      "name": "IFP - Screen Size 86\" 8/128 GB",
      "materialCode": "1100007540"
    },
    {
      "name": "IFP with CAM & 8A MIC - 65\" 4K/8GB/128GB",
      "materialCode": "1100007551"
    },
    {
      "name": "IFP with CAM & 8A MIC - 75\" 4K/8GB/128GB",
      "materialCode": "1100007552"
    },
    {
      "name": "IFP with CAM & 8A MIC - 86\" 4K/8GB/128GB",
      "materialCode": "1100007553"
    },
    {
      "name": "OPS- i5-11th/12th Gen / 8 GB/ 512GB SSD",
      "materialCode": "1100007544"
    },
    {
      "name": "Floor Stand with Adjustable height",
      "materialCode": "1100007545"
    },
    {
      "name": "ADPM-65\"(8/128)-I5/12th Gen OPS PC 8+512",
      "materialCode": "1100007563"
    },
    {
      "name": "ADPM-65\"8/128-I5/12th G OPS PC 8+512 C&M",
      "materialCode": "1100007564"
    },
    {
      "name": "ADPM-75\"(8/128)-I5/12th Gen OPS PC 8+512",
      "materialCode": "1100007565"
    },
    {
      "name": "ADPM-75\"8/128-I5/12th G OPS PC 8+512-C&M",
      "materialCode": "1100007566"
    },
    {
      "name": "ADPM-86\"(8/128)-I5/12th Gen OPS PC 8+512",
      "materialCode": "1100007567"
    },
    {
      "name": "ADPM-86\"8/128-I5/12th G OPS PC 8+512-C&M",
      "materialCode": "1100007568"
    },
    {
      "name": "ADPM-98\"8/128-I7/12th G OPS PC 8+512-C&M",
      "materialCode": "1100007569"
    },
    {
      "name": "ADPM-110\"8/128-I7/12th G OPS PC 8+512C&M",
      "materialCode": "1100007570"
    },
    {
      "name": "IFPD - 65\" 8/128 GB",
      "materialCode": "1100007571"
    },
    {
      "name": "IFPD - 75\" 8/128 GB",
      "materialCode": "1100007572"
    },
    {
      "name": "IFPD - Size 86\" 8/128 GB",
      "materialCode": "1100007573"
    },
    {
      "name": "IFPD - CAM & 8A MIC - 65\" 4K/8GB/128GB",
      "materialCode": "1100007574"
    },
    {
      "name": "IFPD - CAM & 8A MIC - 75\" 4K/8GB/128GB",
      "materialCode": "1100007575"
    },
    {
      "name": "IFPD - CAM & 8A MIC - 86\" 4K/8GB/128GB",
      "materialCode": "1100007576"
    },
    {
      "name": "OPS- i7-12th Gen / 8 GB/ 512GB SSD",
      "materialCode": "1100007577"
    }
  ]
};

export const ORDER_TYPES = {
  FORWARD: "Forward",
  HARDWARE: "Hardware",
  ADDITIONAL_HARDWARE: "Additional Hardware",
  REPLACEMENT_HARDWARE: "Replacement Hardware",
  IFP_HARDWARE: "IFP Hardware",
  EXPERIENCE_HUB: "Experience Hub",
  SD_CARD: "SD Card",
  RETURN: "Return"
}

export const PRODUCT_VARIANTS = {
  LEAD: "Lead",
  PINNACLE: "Pinnacle+",
  PROPEL: "Propel"
}

export const NEW_PRODUCT_VARIANTS = {
  ACTIVE_TEACH: "Active Teach",
  ACADEMIA: "Academia",
  BUILDR: "Buildr"
}